import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import ForcedPasswordChange from "./pages/ForcedPasswordChange";
import Dashboard from "./pages/Dashboard";
import AdminHome from "./pages/HomeAdmin";
import HomeDriver from "./pages/HomeDriver";
import DriverDeliveries from "./pages/DriverDeliveries";
import DriverPickups from "./pages/DriverPickups";
import DriverProfile from "./pages/DriverProfile";
import SellerHome from "./pages/SellerHome";
import SellerDeliveries from "./pages/SellerDeliveries";
import SellerDeliveryCreate from "./pages/SellerDeliveryCreate";
import Totales from "./pages/Totales";
import Stores from "./pages/Stores";
import PriceLists from "./pages/PriceLists";
import ZonesPage from "./pages/ZonesPage";
import WarehousesPage from "./pages/WarehousesPage";
import Users from "./pages/Users";
import ManualLoad from "./pages/ManualLoad";
import Deliveries from "./pages/Deliveries";
import EnviosLegacy from "./pages/EnviosLegacy";
import LiquidacionesClientes from "./pages/LiquidacionesClientes";
import LiquidacionesChoferes from "./pages/LiquidacionesChoferes";
import LiquidacionesDashboard from "./pages/LiquidacionesDashboard";
import LiquidacionesHistorial from "./pages/LiquidacionesHistorial";
import ReportesOperativos from "./pages/ReportesOperativos";
import DeliveriesLoad from "./pages/DeliveriesLoad";
import EtiquetasImpresion from "./pages/EtiquetasImpresion";
import LynxPack from "./pages/LynxPack";
import Performance from "./pages/Performance";
import RoutesPage from "./pages/RoutesPage";
import ColectasFijasPage from "./pages/ColectasFijasPage";
import ShelvesPage from "./pages/ShelvesPage";
import PlantaPage from "./pages/PlantaPage";
import MapaChoferesPage from "./pages/MapaChoferesPage";
import OperacionPage from "./pages/OperacionPage";
import TurboConfigPage from "./pages/TurboConfigPage";
import TurboDispatchesPage from "./pages/TurboDispatchesPage";

import AdminLayout from "./Layouts/AdminLayout";
import DriverLayout from "./Layouts/DriverLayout";
import SellerLayout from "./Layouts/SellerLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import RequireCapability from "./components/auth/RequireCapability";
import RequireReportsAccess from "./components/auth/RequireReportsAccess";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* Ver informe "LYNX — Fase 1.2.9": sin allowedRoles — cualquier rol
            autenticado puede (y, si mustChangePassword es true, DEBE) caer
            acá. ProtectedRoute es quien la excluye de su propio chequeo. */}
        <Route element={<ProtectedRoute />}>
          <Route path="/cambiar-password" element={<ForcedPasswordChange />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />

            <Route path="envios" element={<Deliveries />} />
            <Route path="envios/legacy" element={<EnviosLegacy />} />
            <Route path="envios/carga" element={<DeliveriesLoad />} />
<Route path="envios/lynxpack" element={<LynxPack />} />
            <Route path="envios/etiquetas" element={<EtiquetasImpresion />} />

            <Route path="recorridos" element={<RoutesPage />} />
            <Route path="recorridos/fijas" element={<ColectasFijasPage />} />
            <Route path="envios/rutear" element={<Navigate to="/admin/recorridos" replace />} />

            <Route element={<RequireCapability capability="warehouse_access" />}>
              <Route path="deposito/planta" element={<PlantaPage />} />
              <Route path="deposito/estanterias" element={<ShelvesPage />} />
            </Route>
            <Route path="choferes/mapa" element={<MapaChoferesPage />} />
            <Route path="operacion" element={<OperacionPage />} />
            <Route path="turbo/despachos" element={<TurboDispatchesPage />} />
            <Route path="turbo/config" element={<TurboConfigPage />} />

            <Route path="performance" element={<Performance />} />

            <Route element={<RequireCapability capability="finance_access" />}>
              <Route path="liquidaciones/dashboard" element={<LiquidacionesDashboard />} />
              <Route path="liquidaciones/historial" element={<LiquidacionesHistorial />} />
              <Route path="liquidaciones/clientes" element={<LiquidacionesClientes />} />
              <Route path="liquidaciones/choferes" element={<LiquidacionesChoferes />} />
            </Route>
            {/* Carga manual y Totales (incluye Reset DB) piden db_access en
                el backend (server/legacy/utils.js), no finance_access —
                aunque viven en la sección "Liquidaciones" del Sidebar, ver
                informe "LYNX — Fase 1.2A". Antes de este cambio quedaban
                fuera de cualquier guard de ruta. */}
            <Route element={<RequireCapability capability="db_access" />}>
              <Route path="liquidaciones/carga-manual" element={<ManualLoad />} />
              <Route path="liquidaciones/totales" element={<Totales />} />
              <Route path="totales" element={<Totales />} />
            </Route>

            <Route element={<RequireReportsAccess />}>
              <Route path="reportes-operativos" element={<ReportesOperativos />} />
            </Route>

            {/* Stores y Sistema/Tarifas piden db_access en el backend
                (server/current/seller/store.js, server/current/tariff.js) —
                ver auditoría de cierre "LYNX Fase 1", Bloqueador 1: antes de
                este cambio quedaban sin guard de ruta ni ocultas en el
                Sidebar, mismo patrón que Carga manual/Totales arriba. */}
            <Route element={<RequireCapability capability="db_access" />}>
              <Route path="stores" element={<Stores />} />
              <Route path="sistema/listas-de-precios" element={<PriceLists />} />
              <Route path="sistema/zonas" element={<ZonesPage />} />
              <Route path="sistema/warehouses" element={<WarehousesPage />} />
            </Route>
            <Route element={<RequireCapability capability="user_access" />}>
              <Route path="users" element={<Users />} />
            </Route>

            <Route path="dashboard" element={<Dashboard />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["DRIVER"]} />}>
          <Route path="/driver" element={<DriverLayout />}>
            <Route index element={<HomeDriver />} />
            <Route path="deliveries" element={<DriverDeliveries />} />
            <Route path="pickups" element={<DriverPickups />} />
            <Route path="profile" element={<DriverProfile />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["SELLER"]} />}>
          <Route path="/seller" element={<SellerLayout />}>
            <Route index element={<SellerHome />} />
            <Route path="envios" element={<SellerDeliveries />} />
            <Route path="envios/nuevo" element={<SellerDeliveryCreate />} />
            <Route path="envios/impresion" element={<EtiquetasImpresion />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;